module.exports = __webpack_public_path__ + "img/Expo-Amy-Galper-Build-Your-Aromatherapy-Business.6a0c1487.png";